// Firebase Configuration
// This is the actual configuration file used by the application
// Copy from firebase-config.sample.js and update with your project settings

// Production Firebase Config
const productionConfig = {
  apiKey: "AIzaSyD1Tpq8JrlPJjU6e3BtU-ClwA_Ke01Yv64",
  authDomain: "refectory-15528.firebaseapp.com",
  projectId: "refectory-15528",
  storageBucket: "refectory-15528.firebasestorage.app",
  messagingSenderId: "340046707017",
  appId: "1:340046707017:web:bc2157ab1faf09694c4298"
};

// Staging Firebase Config (replace with your actual staging config)
const stagingConfig = {
  apiKey: "AIzaSyCbXGcrAqBtZ08Y64iFhz8VaXiATBJc7Z4",
  authDomain: "refectory-15528-staging.firebaseapp.com",
  projectId: "refectory-15528-staging",
  storageBucket: "refectory-15528-staging.firebasestorage.app",
  messagingSenderId: "440173058232",
  appId: "1:440173058232:web:966434b8669610ead33c4d"
};


// Auto-detect environment based on hostname
const isStaging = typeof window !== 'undefined' &&
  (window.location.hostname.includes('staging') ||
   window.location.hostname.includes('refectory-15528-staging'));

// Export the appropriate config
export const firebaseConfig = isStaging ? stagingConfig : productionConfig;

// Emulator settings - automatically used in development
export const useEmulator = process.env.REACT_APP_FIREBASE_USE_EMULATOR === 'true' || process.env.NODE_ENV === 'development';

export const emulatorConfig = {
  auth: process.env.REACT_APP_FIREBASE_AUTH_EMULATOR_HOST || 'localhost:9099',
  firestore: process.env.REACT_APP_FIREBASE_FIRESTORE_EMULATOR_HOST || 'localhost:8080',
  functions: process.env.REACT_APP_FIREBASE_FUNCTIONS_EMULATOR_HOST || 'localhost:5001'
};
